(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.kk-collections [data-carousel]').forEach(initCarousel);

    function initCarousel(carousel) {
      const track = carousel.querySelector('[data-track]');
      const slides = carousel.querySelectorAll('.kk-carousel__slide');
      const prevBtn = carousel.querySelector('[data-prev]');
      const nextBtn = carousel.querySelector('[data-next]');
      const block = carousel.closest('.kk-collections__block');
      const dotsContainer = block ? block.querySelector('[data-dots]') : null;
      const section = carousel.closest('.kk-collections');

      if (!track || slides.length === 0) return;

      let currentIndex = 0;
      let slidesPerView = getSlidesPerView();
      let autoplayInterval = null;

      function getSlidesPerView() {
        const width = window.innerWidth;
        if (width <= 768) return parseInt(section.dataset.mobileCards) || 2;
        if (width < 990) return 2;
        return parseInt(getComputedStyle(section).getPropertyValue('--kk-cards-desktop')) || 4;
      }

      function getMaxIndex() {
        return Math.max(0, slides.length - slidesPerView);
      }

      function updateCarousel() {
        if (window.innerWidth <= 768) {
          track.style.transform = '';
          return;
        }

        const slideWidth = slides[0].offsetWidth;
        const gap = parseInt(getComputedStyle(track).gap) || 24;
        const offset = currentIndex * (slideWidth + gap);
        track.style.transform = `translateX(-${offset}px)`;

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();

        if (dotsContainer) {
          dotsContainer.querySelectorAll('.kk-carousel__dot').forEach((dot, i) => {
            dot.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');
          });
        }
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        const totalDots = getMaxIndex() + 1;
        if (totalDots <= 1) return;
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'kk-carousel__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => { currentIndex = i; updateCarousel(); resetAutoplay(); });
          dotsContainer.appendChild(dot);
        }
      }

      function next() {
        if (window.innerWidth <= 768) return;
        currentIndex = currentIndex < getMaxIndex() ? currentIndex + 1 : 0;
        updateCarousel();
      }
      function prev() {
        if (window.innerWidth <= 768) return;
        currentIndex = currentIndex > 0 ? currentIndex - 1 : getMaxIndex();
        updateCarousel();
      }

      function startAutoplay() {
        if (window.innerWidth <= 768) return;
        const enabled = section.dataset.autoplay === 'true';
        const speed = parseInt(section.dataset.autoplaySpeed) || 5000;
        if (!enabled || slides.length <= slidesPerView) return;
        autoplayInterval = setInterval(next, speed);
      }
      function stopAutoplay() {
        if (autoplayInterval) { clearInterval(autoplayInterval); autoplayInterval = null; }
      }
      function resetAutoplay() { stopAutoplay(); startAutoplay(); }

      if (prevBtn) prevBtn.addEventListener('click', () => { prev(); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { next(); resetAutoplay(); });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          slidesPerView = getSlidesPerView();
          if (currentIndex > getMaxIndex()) currentIndex = getMaxIndex();
          buildDots();
          updateCarousel();
        }, 150);
      });

      buildDots();
      updateCarousel();
      startAutoplay();
    }

    // ===== QUICK ADD =====
    document.querySelectorAll('[data-quick-add]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.dataset.variantId;
        const singleVariant = btn.dataset.singleVariant === 'true';
        const productUrl = btn.dataset.productUrl;

        // Multi-variant products go to the product page to choose options
        if (!singleVariant) {
          if (productUrl) window.location.href = productUrl;
          return;
        }
        if (!variantId) return;

        btn.classList.add('is-loading');
        btn.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart add failed');
          await response.json();

          let itemCount;
          try {
            const cart = await fetch('/cart.js').then(r => r.json());
            itemCount = cart.item_count;
          } catch (e) {}

          // Dwell (Horizon) cart event: refreshes the drawer, updates the
          // cart bubble, and auto-opens the drawer. This is the key fix.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { source: 'collection-showcase', itemCount: itemCount } }
          }));

          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          setTimeout(() => {
            btn.classList.remove('is-success');
            btn.disabled = false;
          }, 1600);
        } catch (err) {
          console.error('Quick Add error:', err);
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (productUrl) window.location.href = productUrl;
        }
      });
    });

    // ===== BUY NOW =====
    document.querySelectorAll('[data-buy-now]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.dataset.variantId;
        const singleVariant = btn.dataset.singleVariant === 'true';
        const productUrl = btn.dataset.productUrl;

        if (!singleVariant) {
          if (productUrl) window.location.href = productUrl;
          return;
        }
        if (!variantId) return;

        btn.classList.add('is-loading');
        btn.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart add failed');
          window.location.href = '/checkout';
        } catch (err) {
          console.error('Buy Now error:', err);
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (productUrl) window.location.href = productUrl;
        }
      });
    });

    // ===== WISHLIST HEART FALLBACK =====
    // If the XB Wishlist app doesn't properly toggle the filled state
    // (e.g., replaces the button DOM and loses the "in wishlist" indicator),
    // this fallback keeps our own copy of the heart state in localStorage
    // and swaps between empty and filled SVG on click.
    // If the app IS working, this runs in parallel and doesn't interfere.
    function getWishlistState() {
      try {
        return JSON.parse(localStorage.getItem('kk_wishlist') || '[]');
      } catch (e) { return []; }
    }
    function saveWishlistState(list) {
      try { localStorage.setItem('kk_wishlist', JSON.stringify(list)); } catch (e) {}
    }
    function updateHeartIcon(btn, isInWishlist) {
      const empty = btn.querySelector('.kk-wishlist-icon--empty');
      const filled = btn.querySelector('.kk-wishlist-icon--filled');
      if (empty) empty.style.display = isInWishlist ? 'none' : '';
      if (filled) filled.style.display = isInWishlist ? '' : 'none';
    }
    function initWishlistButtons() {
      const list = getWishlistState();
      document.querySelectorAll('.kk-wishlist-btn').forEach(btn => {
        const card = btn.closest('.kk-card');
        if (!card) return;
        const productId = card.dataset.productId;
        if (!productId) return;

        // Set initial state on page load
        updateHeartIcon(btn, list.indexOf(productId) !== -1);

        // Only bind once
        if (btn.dataset.kkBound === 'true') return;
        btn.dataset.kkBound = 'true';

        btn.addEventListener('click', (e) => {
          // Give the wishlist app a chance to handle its own logic first,
          // then toggle our own visual state as a safety net.
          setTimeout(() => {
            const currentList = getWishlistState();
            const idx = currentList.indexOf(productId);
            if (idx === -1) {
              currentList.push(productId);
              updateHeartIcon(btn, true);
            } else {
              currentList.splice(idx, 1);
              updateHeartIcon(btn, false);
            }
            saveWishlistState(currentList);
          }, 50);
        });
      });
    }
    initWishlistButtons();
    // Re-check periodically in case the app re-renders buttons
    setTimeout(initWishlistButtons, 1500);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-carousal"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousels = document.querySelectorAll('.kk-carousel');

    carousels.forEach(carousel => {
      const track = carousel.querySelector('[data-track]');
      const slides = carousel.querySelectorAll('.kk-carousel__slide');
      const prevBtn = carousel.querySelector('[data-prev]');
      const nextBtn = carousel.querySelector('[data-next]');
      const dotsContainer = carousel.querySelector('[data-dots]');

      if (!track || slides.length === 0) return;

      let currentIndex = 0;
      let slidesPerView = 4;
      let autoplayInterval = null;

      function getSlidesPerView() {
        const width = window.innerWidth;
        if (width < 600) return 1;
        if (width < 990) return 2;
        return 4;
      }

      function getMaxIndex() {
        return Math.max(0, slides.length - slidesPerView);
      }

      function updateCarousel() {
        if (slides.length === 0) return;
        const slideWidth = slides[0].offsetWidth;
        const gap = parseInt(window.getComputedStyle(track).gap) || 24;
        const offset = currentIndex * (slideWidth + gap);
        track.style.transform = `translateX(-${offset}px)`;

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();

        if (dotsContainer) {
          const dots = dotsContainer.querySelectorAll('.kk-carousel__dot');
          dots.forEach((dot, i) => {
            dot.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');
          });
        }
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        const totalDots = getMaxIndex() + 1;
        if (totalDots <= 1) return;

        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'kk-carousel__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => {
            currentIndex = i;
            updateCarousel();
            resetAutoplay();
          });
          dotsContainer.appendChild(dot);
        }
      }

      function next() {
        if (currentIndex < getMaxIndex()) {
          currentIndex++;
        } else {
          currentIndex = 0;
        }
        updateCarousel();
      }

      function prev() {
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = getMaxIndex();
        }
        updateCarousel();
      }

      function startAutoplay() {
        const enabled = carousel.dataset.autoplay === 'true';
        const speed = parseInt(carousel.dataset.autoplaySpeed) || 5000;
        if (!enabled || slides.length <= slidesPerView) return;
        autoplayInterval = setInterval(next, speed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      if (prevBtn) prevBtn.addEventListener('click', () => { prev(); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { next(); resetAutoplay(); });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);

      let touchStartX = 0;
      let touchEndX = 0;
      track.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay();
      }, { passive: true });
      track.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) next();
          else prev();
        }
        startAutoplay();
      }, { passive: true });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          slidesPerView = getSlidesPerView();
          if (currentIndex > getMaxIndex()) currentIndex = getMaxIndex();
          buildDots();
          updateCarousel();
        }, 150);
      });

      slidesPerView = getSlidesPerView();
      buildDots();
      updateCarousel();
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
